import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input, Select, Button, DatePicker, Icon, message } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import SelectProvince from '../../common/SelectProvince';
import TableC from '../../basicElement/TableC';
import EditTableCell from './EditTableCell';
import UpdateAbroadRecord from './UpdateAbroadRecord';
import UpdateChargeHospitalRecord from './UpdateChargeHospitalRecord';
import $ from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';
import PreviewModal from '../PreviewModal';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import moment from 'moment';
import renderEnhancer from '../../shared/renderEnhancer';
import cellRenderEnhancer, { beforeChangeEnhancer } from '../../shared/cellRenderEnhancer';
import { saveParams } from '../../../actions/PersonalActions';

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;
//手动维护的数据 文字显示为蓝色
const MANUAL_BLUE = '#108ee9';
const renderManualText = (text, record, flagKey) => (
    record[flagKey] == 1 && text ? <span style={{ color: MANUAL_BLUE }}>{text}</span> : text
);
//renderEnhancer 包裹的列 单元格返回 {children, props} 结构 只对 children 标蓝
const renderManualEnhancer = (render, flagKey) => (text, record, index) => {
    const cell = render(text, record, index);
    if (record[flagKey] == 1 && cell && cell.children !== undefined) {
        return {
            children: <span style={{ color: MANUAL_BLUE }}>{cell.children}</span>,
            props: cell.props,
        };
    }
    return cell;
};

class Filter extends Component {
    state = {
        searchParams: {
            workStatus: 'WORKING',
            queryDate:''
        },
        expand: false,
        enterpriseDepartmentList: [],
    }

    componentDidMount() {
        const { employeeCode } = this.props;
        const { searchParams } = this.state;
        this.setState({
            searchParams: {
                ...searchParams,
                employeeCode,
            },
        },() => {
            this.queryDate();
            this.queryUserDepartmentList();
        })
    }

    queryDate= () => {
        const { searchParams } =this.state
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({searchParams:{ ...searchParams , queryDate:`${res.trueYear}-${res.trueMonth}`}},()=> this.search());
        });
    }

    queryUserDepartmentList = () => {
        dictCache.getDict('USER_DEPT_LEVEL_5', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.user.queryUserDepartmentSelect,
                data: { level: 5 },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { data } = res;
            this.setState({ enterpriseDepartmentList: data });
        });
    }

    search = () => {
        const {
            searchParams,
            searchParams: {
                areaParams,
            },
        } = this.state;
        this.props.search({ ...searchParams, ...areaParams, areaParams: '', hasCheckedArea: '' });
    }

    export = () => {
        this.props.export();
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleDateChange = (data, dateString, field) => {
        const { searchParams } = this.state;
        searchParams[field] = dateString;
        this.setState({ searchParams });
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        if (field == 'enterpriseDepartmentId') {
            searchParams[field] = value;
            searchParams.xjDeptId = undefined;
            searchParams.xjDeptName = undefined;
            searchParams.positionId = undefined;
            searchParams.positionName = undefined;
        } else {
            searchParams[field] = value;
        }
        this.setState({ searchParams });
    }

    saveProvince = (checkedArea) => {
        const { searchParams } = this.state;
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        this.setState({
            searchParams: {
                ...searchParams,
                areaParams,
                hasCheckedArea,
                areaName: areaList.join(','),
            }
        });
    }

    handleSearchRetrieveChange = (option, key) => {
        const { searchParams } = this.state;
        const { value, text } = option || {};
        switch (key) {
            case 'xjDept':
                searchParams.xjDeptId = value;
                searchParams.xjDeptName = text;
                searchParams.positionId = undefined;
                searchParams.positionName = undefined;
                break;
            case 'position':
                searchParams.positionId = value;
                searchParams.positionName = text;
                break;
            case 'leader':
                searchParams.leaderId = value;
                searchParams.leaderName = text;
                break;
            case 'hospital':
                searchParams.hospitalId = value;
                searchParams.hospitalName = text;
                break;
            case 'mainChargeHospital':
                searchParams.mainChargeHospitalMainId = value;
                searchParams.mainChargeHospitalName = text;
                break;
            default:
                break;
        }
        this.setState({
            searchParams,
        });
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    render() {
        const {
            searchParams: {
                joinTime,
                positiveTime,
                employeeCode,
                userCompellation,
                companyName,
                areaName,
                workStatus,
                hasCheckedArea = [],
                enterpriseDepartmentId,
                enterpriseDepartmentName,
                xjDeptId,
                xjDeptName,
                xxjDeptId,
                xxjDeptName,
                positionId,
                positionName,
                leaderId,
                leaderName,
                hospitalId,
                mainChargeHospitalMainId,
                hospitalName,
                queryDate,
                isAbroad,
                mainChargeHospitalDepartment,
                mainChargeHospitalName,
            },
            expand,
            enterpriseDepartmentList,
        } = this.state;
        const maxHeight = expand ? 280 : 40;
        const newqueryDate = queryDate ? moment(queryDate) : null;
        const newJoinTime = joinTime ? moment(joinTime) : null;
        const newPositiveTime = positiveTime ? moment(positiveTime) : null;
        const enterpriseDepartmentOptions = enterpriseDepartmentList.map(el => <Option value={el.enterpriseDepartmentId}>{el.enterpriseDepartmentName}</Option>)
        return (
            <div>
                <div className="search-bar bar2 expand" style={{ marginBottom: 10, maxHeight: maxHeight }}>
                <div className="expand-box">
                    <a onClick={this.toggleHeight}>
                        {expand ? "收起" : "展开"}
                        <Icon className="expand-icon" type={expand ? "up" : "down"} />
                    </a>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">时间</label>
                    <MonthPicker
                        style={{ width: 100 }}
                        allowClear={false}
                        format={monthFormat}
                        value={newqueryDate}
                        placeholder="请选择"
                        disabledDate={(current)=>{return current && current.valueOf() < moment('2022-11');}}
                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'queryDate')}
                        className="w-100-select"
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">工号</label>
                    <Input
                        placeholder="请输入"
                        value={employeeCode}
                        style={{ width: 120 }}
                        onChange={e => this.handleInputChange(e, 'employeeCode')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">姓名</label>
                    <Input
                        placeholder="请输入"
                        style={{ width: 120 }}
                        value={userCompellation}
                        onChange={e => this.handleInputChange(e, 'userCompellation')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">公司名称</label>
                    <Input
                        placeholder="请输入"
                        style={{ width: 140 }}
                        value={companyName}
                        onChange={e => this.handleInputChange(e, 'companyName')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">部门</label>
                    <Select
                        style={{ width: 160 }}
                        allowClear={true}
                        placeholder="请选择"
                        value={enterpriseDepartmentId}
                        onChange={value => this.handleSelectChange(value, 'enterpriseDepartmentId')}
                    >
                        {enterpriseDepartmentOptions}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">下级组织</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 142 }}
                        placeholder="输入下级组织检索"
                        value={xjDeptId}
                        params={{ limit: 20, level: 6, parentId: enterpriseDepartmentId }}
                        url={API_URL.user.queryUserDepartmentSelect}
                        config={{ id: 'enterpriseDepartmentId', name: 'enterpriseDepartmentName' }}
                        onChange={(option) => this.handleSearchRetrieveChange(option, 'xjDept')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">职位级别</label>
                    <SearchRetrieve
                        keyword='positionName'
                        style={{ width: 142 }}
                        placeholder="输入职位检索"
                        value={positionName}
                        params={{ limit: 20, enterpriseDepartmentId: xjDeptId ? xjDeptId : enterpriseDepartmentId}}
                        url={API_URL.team.queryUserPositionSelect}
                        config={{ id: 'positionId', name: 'positionName' }}
                        onChange={(option) => this.handleSearchRetrieveChange(option, 'position')}
                    />
                </div>
                <div className="search-item">
                    <label className="ui-label">主管领导</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 160 }}
                        placeholder="输入姓名/工号检索"
                        value={leaderName}
                        params={{ limit: 20 }}
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={(option) => this.handleSearchRetrieveChange(option, 'leader')}
                    />
                </div>
                <div className="search-item">
                    <label className="ui-label">区域/城市</label>
                    <SelectProvince areaName={areaName} saveProvince={this.saveProvince} hasCheckedArea={hasCheckedArea} />
                </div>
                <div className="search-item">
                    <label className="ui-label">参与中心情况</label>
                    <SearchRetrieve
                        keyword='hospitalName'
                        style={{ width: 200 }}
                        placeholder="输入医院检索"
                        value={hospitalId}
                        params={{ limit: 20 }}
                        url={API_URL.hospital.hospitalList}
                        config={{ id: 'hospitalId', name: 'hospitalName' }}
                        onChange={(option) => this.handleSearchRetrieveChange(option, 'hospital')}
                    />
                </div>
                <div className="search-item">
                    <label className="ui-label">主要负责医院</label>
                    <SearchRetrieve
                        keyword='hospitalName'
                        style={{ width: 200 }}
                        placeholder="输入医院检索"
                        value={mainChargeHospitalMainId}
                        params={{ limit: 20 }}
                        url={API_URL.hospital.queryHospitalMainList}
                        config={{ id: 'hospitalMainId', name: 'hospitalMainName'}}
                        onChange={(option) => this.handleSearchRetrieveChange(option, 'mainChargeHospital')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">主要负责科室</label>
                    <Input
                        placeholder="请输入"
                        value={mainChargeHospitalDepartment}
                        style={{ width: 120 }}
                        onChange={e => this.handleInputChange(e, 'mainChargeHospitalDepartment')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">是否驻外</label>
                    <Select
                        onChange={value => this.handleSelectChange(value, 'isAbroad')}
                        placeholder="请选择"
                        value={isAbroad}
                        style={{ width: 90 }}
                        allowClear={true}
                    >
                        <Option value="1">是</Option>
                        <Option value="0">否</Option>
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">状态</label>
                    <Select
                        onChange={value => this.handleSelectChange(value, 'workStatus')}
                        placeholder="请选择"
                        value={workStatus}
                        style={{ width: 90 }}
                        allowClear={true}
                    >
                        <Option value="WORKING">在职</Option>
                        <Option value="LEFT">离职</Option>
                    </Select>
                </div>
                <div className="search-item">
                    <label className="ui-label">入职时间</label>
                    <MonthPicker
                        style={{ width: 100 }}
                        format={monthFormat}
                        value={newJoinTime}
                        placeholder="请选择"
                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'joinTime')}
                        className="w-100-select"
                    />
                </div>
                <div className="search-item">
                    <label className="ui-label">转正时间</label>
                    <MonthPicker
                        style={{ width: 100 }}
                        format={monthFormat}
                        value={newPositiveTime}
                        placeholder="请选择"
                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'positiveTime')}
                        className="w-100-select"
                    />
                </div>
                
            </div>
            <div className="search-item" style={{ textAlign:'right', marginBottom:10}}>
                    <Button type="primary" style={{ margin:'0 10px'}} onClick={this.search}>搜索</Button>
                    <Button type="primary" style={{ margin:'0 10px'}} onClick={this.export}>导出</Button>
                </div>
            </div>
        );
    }
}

class OverView extends Component {
    state = {
        sortParams: {},
        searchParams: {},
        pagination: {
            current: 1,
            pageSize: 10,
        },
        loading: false,
        data: [],
        CourtyardAreaList: [],
        edit: false,
    }

    search = (params) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: params,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const params = {
            ...sortParams,
            ...searchParams,
            exportType: 'employeeInfoOverview'
        }
        ExportUtil.export(params, pagination, API_URL.user.exportEmployeeList);
        message.success('人员信息总览开始导出，请在右上角“下载站”中查看导出进度，下载导出文件，请勿重复导出')
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.getEmpInfoList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
                positionId: '',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;

                this.setState({
                    pagination,
                    data: datas,
                    loading: false,
                });
            }
        };
        $.sendRequest(options);
    }

    getDateRender = text => text ? text.slice(0, 10) : ''

    getColumns = () => {
        const { searchParams: { queryDate } } = this.state;
        //时间选择框选择的是历史月份时 显示固化数据修改操作列
        const isHistoryMonth = !!queryDate && queryDate < moment().format('YYYY-MM');
        const columns = [
        {
            title: '时间',
            dataIndex: 'yearMonth',
            key: 'yearMonth',
            fixed: 'left',
            width: 80,
            // render:()=>{
            //     const { searchParams:{queryDate}} = this.state;
            //     return (<span>{queryDate}</span>)
            // }
        }, {
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 80,
            sorter: true,
            fixed: 'left',
            render: (text, record) => {
                const { userId } = record;
                return <a onClick={() => this.showPreviewModal(userId)}>{text}</a>;
            }
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            fixed: 'left',
            sorter: true,
            width: 80,
        }, {
            title: '职位/级别',
            dataIndex: 'positionName',
            key: 'positionName',
            sorter: true,
            width: 120,
        }, {
            title: '主管领导工号',
            dataIndex: 'leaderCode',
            key: 'leaderCode',
            sorter: true,
            width: 120,
        }, {
            title: '主管领导姓名',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 100,
        }, {
            title: '公司名称',
            dataIndex: 'companyName',
            key: 'companyName',
            width: 160,
        }, {
            title: '部门',
            dataIndex: 'enterpriseDepartmentName',
            key: 'enterpriseDepartmentName',
            sorter: true,
            width: 120,
        }, {
            title: '下级组织',
            dataIndex: 'xjDepName',
            key: 'xjDepName',
            width: 120,
            render: text => text ? text : '-',
        }, {
            title: '手机号码',
            dataIndex: 'userMobile',
            key: 'userMobile',
            width: 100,
        }, {
            title: '邮箱',
            dataIndex: 'email',
            key: 'email',
            width: 180,
        }, {
            title: '工作城市',
            dataIndex: 'workCity',
            key: 'workCity',
            sorter: true,
            width: 100,
        }, {
            title: '入职时间',
            dataIndex: 'joinTime',
            key: 'joinTime',
            sorter: true,
            width: 100,
            render: this.getDateRender,
        }, {
            title: '临床试验经验年限(月)',
            dataIndex: 'workingLife',
            key: 'workingLife',
            width: 80,
        }, {
            title: '涉及项目领域/疾病',
            dataIndex: 'areaDisease',
            key: 'areaDisease',
            width: 200,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {areaDisease } = record;
                        const areaDiseaseList = areaDisease?areaDisease.split(';'):[]
                        if ((areaDiseaseList || []).length > 1) {
                            return (
                                <div>
                                    {
                                        areaDiseaseList.map((value,index) => (
                                            value.length > 50 ?
                                            <div style={{ width:500, wordWrap:'break-word' }} key={index}>
                                                {value} 
                                            </div>:
                                            <div key={index}>
                                            {value} 
                                        </div>
                                        ))
                                    }
                                </div>
                            );
                        }
                    }
                })(text => text?text.split(';')[0].substring(0,30):'')
            ),
        }, {
            title: '带教老师工号',
            dataIndex: 'teacherCode',
            key: 'teacherCode',
            width: 100,
            render: (text, record) => <EditTableCell text={text} record={record} activeKey="promotion" onChange={this.props.onChange} />
        }, {
            title: '带教老师姓名',
            dataIndex: 'teacherName',
            key: 'teacherName',
            width: 100,
            render: (text, record) => {
                return <EditTableCell text={text} record={record} activeKey="promotion" onChange={this.props.onChange} />;
            }
        }, {
            title: '转正时间',
            dataIndex: 'positiveTime',
            key: 'positiveTime',
            sorter: true,
            width: 100,
            render: this.getDateRender,
            // render: (text, record) => {
            //     text = this.getDateRender(text);
            //     return <EditTableCell text={text} record={record} activeKey="promotion" onChange={this.props.onChange} />;
            // }
        }, {
            title: '晋升时间',
            dataIndex: 'userPromotion',
            key: 'userPromotion',
            width: 140,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {userPromotion } = record;
                        const userPromotionList = userPromotion?userPromotion.split(';'):[]
                        if ((userPromotionList || []).length > 1) {
                            return (
                                <div>
                                    {
                                        userPromotionList.map((value,index) => (
                                            <div key={index}>
                                                {value} 
                                            </div>
                                        ))
                                    }
                                </div>
                            );
                        }
                    }
                })(text => text?text.split(';')[0].substring(0,30):'')
            ),
        }, {
            title: '参与中心情况',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 160,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {hospitalName } = record;
                        const hospitalNameList = hospitalName?hospitalName.split(','):[]
                        if ((hospitalNameList || []).length > 1) {
                            return (
                                <div>
                                    {
                                        hospitalNameList.map((value,index) => (
                                            <div key={index}>
                                                {value} 
                                            </div>
                                        ))
                                    }
                                </div>
                            );
                        }
                    }
                })(text => text?text.split(',')[0].substring(0,30):'')
            ),
        }, {
            title: '休假',
            dataIndex: 'userVacate',
            key: 'userVacate',
            width: 200,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {userVacate } = record;
                        const userVacateList = userVacate?userVacate.split(','):[]
                        if ((userVacateList || []).length > 1) {
                            return (
                                <div>
                                    {
                                        userVacateList.map((value,index) => (
                                            <div key={index}>
                                                {value} 
                                            </div>
                                        ))
                                    }
                                </div>
                            );
                        }
                    }
                })(text => text?text.split(',')[0]:'')
            ),
        }, {
            title: '是否驻外',
            dataIndex: 'isAbroad',
            key: 'isAbroad',
            width:80,
            render:text => text == 1 ? '是' : text == 0 ? '否' : ''
        }, {
            title: '驻外时间',
            dataIndex: 'abroadTime',
            key: 'abroadTime',
            width: 100,
        }, {
            title: '主要负责城市',
            dataIndex: 'mainChargeCity',
            key: 'mainChargeCity',
            width: 160,
        }, {
            title: '主要负责医院',
            dataIndex: 'mainChargeHospital',
            key: 'mainChargeHospital',
            width: 160,
            render: (text, record) => renderManualText(text, record, 'mainManualFlag'),
        }, {
            title: '主要负责院区',
            dataIndex: 'mainChargeCourtyardArea',
            key: 'mainChargeCourtyardArea',
            width: 160,

            render: ( text, record, index) => {
                const { edit, canChooseCourtyardArea, hospitalMainId, userId, hospitalId, mainChargeCourtyardArea, mainManualFlag } = record;
                const { CourtyardAreaList } = this.state;
                const CourtyardAreaOptions = CourtyardAreaList.map(i => <Option key={i.hospitalId}>{i.courtyardArea}</Option>)
                const { curRole } = sessionStorage;
                const isWrite = curRole === 'BO' || curRole === 'CRCC' || curRole === 'CRCM';
                if (!(isWrite && canChooseCourtyardArea)) {
                    return renderManualText(text, record, 'mainManualFlag');
                }
                return edit ?
                <span>
                    <Select
                        allowClear={true}
                        style={{ width: 100 }}
                        placeholder="请选择"
                        value={ hospitalId ? hospitalId : undefined }
                        onChange={ value => this.handleCourtyardAreaChange( value, index, 'hospitalId' ) }
                    >
                        {CourtyardAreaOptions}
                    </Select>
                    <a style={{marginLeft: 10}} onClick={()=>this.setMainChargeCourtyardArea(userId,hospitalId,!edit,index, hospitalMainId)}>保存</a>
                </span>
                :
                <span style={{ display: 'block', top: '0px',left: '0px',width: '159px',height: '56px',position: 'absolute',paddingLeft: '8px',paddingTop: '20px'}} onClick={()=> this.handleCourtyardAreaChange(!edit,index,'edit',hospitalMainId)}>
                    {mainManualFlag == 1 && text ? <span style={{ color: MANUAL_BLUE }}>{text}</span> : (text ? text : '')}
                </span>
            }
        }, {
            title: '主要负责科室',
            dataIndex: 'mainChargeHospitalDepartment',
            key: 'mainChargeHospitalDepartment',
            width: 160,
            render: (text, record) => renderManualText(text, record, 'mainManualFlag'),
        }, {
            title: '次要负责医院',
            dataIndex: 'secondChargeHospital',
            key: 'secondChargeHospital',
            width: 160,
            render: renderManualEnhancer(renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {secondChargeHospital } = record;
                        const secondChargeHospitalList = secondChargeHospital?secondChargeHospital.split(','):[]
                        if ((secondChargeHospitalList || []).length > 1) {
                            return (
                                <div>
                                    {
                                        secondChargeHospitalList.map((value,index) => (
                                            <div key={index}>
                                                {value}
                                            </div>
                                        ))
                                    }
                                </div>
                            );
                        }
                    }
                })(text => text?text.split(',')[0]:'')
            ), 'secondManualFlag'),
        }, {
            title: '次要负责科室',
            dataIndex: 'secondChargeHospitalDepartment',
            key: 'secondChargeHospitalDepartment',
            width: 160,
            render: renderManualEnhancer(renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {secondChargeHospitalDepartment } = record;
                        const secondChargeHospitalDepartmentList = secondChargeHospitalDepartment?secondChargeHospitalDepartment.split(','):[]
                        if ((secondChargeHospitalDepartmentList || []).length > 1) {
                            return (
                                <div>
                                    {
                                        secondChargeHospitalDepartmentList.map((value,index) => (
                                            <div key={index}>
                                                {value}
                                            </div>
                                        ))
                                    }
                                </div>
                            );
                        }
                    }
                })(text => text?text.split(',')[0]:'')
            ), 'secondManualFlag'),
        }, {
            title: '状态',
            dataIndex: 'workStatus',
            key: 'workStatus',
            width: 60,
        }, {
            title: '离职时间',
            dataIndex: 'leftTime',
            key: 'leftTime',
            width: 100,
            render: this.getDateRender,
        }, {
            title: '离职去向',
            dataIndex: 'leaveTo',
            key: 'leaveTo',
            width: 100,
            render: (text, record) => {
                const { userId, workStatus } = record;
                if (workStatus === '离职') {
                    return <EditTableCell key={userId} text={text} record={record} activeKey="leave" onChange={this.props.onChange} />;
                } else {
                    return text;
                }
            }
        }, {
            title: '去向职位',
            dataIndex: 'leaveToPosition',
            key: 'leaveToPosition',
            width: 80,
            render: (text, record) => {
                const { userId, workStatus } = record;
                if (workStatus === '离职') {
                    return <EditTableCell key={userId} text={text} record={record} activeKey="leave" onChange={this.props.onChange} />;
                } else {
                    return text;
                }
            }
        }, {
            title: '离职原因',
            dataIndex: 'leaveReason',
            key: 'leaveReason',
            width: 160,
            render: (text, record) => {
                const { userId, workStatus } = record;
                if (workStatus === '离职') {
                    return <EditTableCell key={userId} text={text} record={record} activeKey="leave" onChange={this.props.onChange} />;
                } else {
                    return text;
                }
            }
        }];
        if (isHistoryMonth) {
            columns.push({
                title: '操作',
                key: 'recordOperation',
                fixed: 'right',
                width: 150,
                render: (text, record) => {
                    const { canSetAbroad } = record;
                    //仅该人员的直线上级可修改固化数据
                    if (!canSetAbroad) {
                        return null;
                    }
                    return (
                        <div>
                            <div><a onClick={() => this.updateAbroadRecordRef.show(this.getRecordParams(record))}>修改驻外固化</a></div>
                            <div><a onClick={() => this.updateChargeHospitalRecordRef.show(this.getRecordParams(record))}>修改负责医院科室固化</a></div>
                        </div>
                    );
                }
            });
        }
        return columns;
    }

    //固化数据修改弹框入参 recordYearMonth 取时间选择框选择的年月
    getRecordParams = (record) => {
        const { searchParams: { queryDate } } = this.state;
        const { userId, employeeCode, userCompellation } = record;
        return {
            userId,
            employeeCode,
            userCompellation,
            recordYearMonth: queryDate ? Number(queryDate.replace('-', '')) : null,
        };
    }

    getDataSource = () => {
        const { data, pagination: { current, pageSize } } = this.state;
        const dataSource = data.map((item, index) => {
            const { workStatus } = item;
            return {
                index: (current - 1) * pageSize + index + 1,
                ...item,
                workStatus: workStatus ? (workStatus === 'WORKING' ? '在职' : "离职") : '',
            };
        });
        return dataSource;
    }

    handleCourtyardAreaChange = ( value, index, key, hospitalMainId ) => {
        const { data, CourtyardAreaList } = this.state;
        if(hospitalMainId){this.queryCourtyardAreaList(hospitalMainId); data[index].hospitalId = undefined;}
        data[index][key] = value;
        CourtyardAreaList.map((i)=>{
            if(i.hospitalId == value){
                data[index].mainChargeCourtyardArea = i.courtyardArea;
            }
        })
        this.setState({ data },()=>{
            this.getDataSource();
        })
    }

    setMainChargeCourtyardArea = (userId,hospitalId,edit,index) => {
        if(!hospitalId){
            let {data} = this.state;
            data[index].mainChargeCourtyardArea = undefined;
            hospitalId = null;
            return message.warning('请选择主要负责院区！');
        }
        const options = {
            method: 'POST',
            url: API_URL.user.setMainChargeCourtyardArea,
            data: {
                userId,
                hospitalId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.message);
                this.handleCourtyardAreaChange(edit,index,'edit');
                let {data} = this.state;
                data[index].hospitalId = undefined;
                this.setState({data})
            }
        };
        $.sendRequest(options);
    }

    queryCourtyardAreaList = (hospitalMainId) => {
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryHospitalCourtyardAreaList,
            data: {    
                hospitalMainId,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas } = res;
                this.setState({ CourtyardAreaList: datas });
            }
        };
        $.sendRequest(options);
}

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    showVitae = (record) => {
        const { curRole } = sessionStorage; 
        const { userId, workStatus, userCompellation } = record;
        this.props.saveParams({
            userId,
            userName: userCompellation,
            isChinese: true,
            canEdit: workStatus === '在职' && curRole !== 'FIN',
        });
        location.href = `./#/user/curriculumVitae`;
    }

    showPreviewModal = userId => {
        this.previewModalRef.show(userId);
    }

    render() {
        const { loading, pagination, sortParams } = this.state;
        const scrollY = (document.body || document.documentElement).clientHeight - 200;
        const { employeeCode } = this.props;
        return (
            <div>
                <Filter search={this.search} export={this.export} employeeCode={employeeCode} />
                <TableC
                    loading={loading}
                    pagination={pagination}
                    // scrollY={scrollY}
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    data={this.getDataSource()}
                    onChange={this.handleTableChange}
                />
                <PreviewModal ref={el => this.previewModalRef = el} />
                <UpdateAbroadRecord ref={el => this.updateAbroadRecordRef = el} loadData={() => this.loadData()} />
                <UpdateChargeHospitalRecord ref={el => this.updateChargeHospitalRecordRef = el} loadData={() => this.loadData()} />
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params))
    }
}

export default connect(null, mapDispatchToProps)(OverView);


// WEBPACK FOOTER //
// ./src/components/user/userInfo/OverView.js